var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"fab",attrs:{"to":_vm.url,"tooltip":_vm.tooltip}},[_c('span',{staticClass:"icon-add"})])}
var staticRenderFns = []

export { render, staticRenderFns }